import includes from 'lodash/includes'

const RequiresRoleCashier = (to,from,next) => {
  const userRole = window.localStorage.getItem('user_role')
  // console.log('userRole', userRole)
  // return userRole
  if(!includes(['cashier'], userRole)){
    window.localStorage.clear();
		window.location.reload(true);
    return next({
      path: '/login'
    })
  }
  return next();
}

export default RequiresRoleCashier;